import React, { FC } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import MuiDialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogContent, { DialogContentProps } from '@material-ui/core/DialogContent';

import { makeStyles } from '../styles';

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: theme.spacing(1),
  },
}));

type AllowedMUIDialogProps =
  | 'children'
  | 'disableBackdropClick'
  | 'disableEscapeKeyDown'
  | 'maxWidth'
  | 'onClose'
  | 'open'
  | 'fullWidth'
  | 'classes'
  | 'scroll'
  | 'transitionDuration'
  | 'style'
  | 'disableEnforceFocus'
  | 'className'
  | 'PaperProps'
  | 'BackdropProps'
  | 'hideBackdrop';

export interface IDialogProps extends Pick<DialogProps, AllowedMUIDialogProps> {}

const Dialog: FC<IDialogProps> = ({ maxWidth = 'md', ...props }) => {
  const classes = useStyles();

  return (
    <MuiDialog
      classes={{
        ...classes,
        ...(props.classes || {}),
      }}
      maxWidth={maxWidth}
      {...props}
    />
  );
};

export default Dialog;

export const DialogContent: FC<DialogContentProps> = props => (
  <MuiDialogContent dividers {...props} />
);

// REVIEW: necessary to make design-system wrappers for these?
export { DialogActions, DialogContentText, DialogTitle };
